import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import './output.css';
import './index.css';
import JwtAuthBootstrap from './components/Auth/JwtAuthBootstrap';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <JwtAuthBootstrap>
        <App />
      </JwtAuthBootstrap>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
